import React from "react";

const AnimatedLogo = () => {
  return (
    <svg
      viewBox="0 0 188 100"
      className="w-full h-full text-gray-300 dark:text-gray-500"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Candle 1 */}
      <g className="animate-float-1">
        <rect x="10" y="30" width="12" height="40" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="40;35;40"
            dur="2s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="y"
            values="30;35;30"
            dur="2s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="13" y="25" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="25;30;25"
            dur="2s"
            repeatCount="indefinite"
          />
        </rect>
        <rect x="13" y="73" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="73;68;73"
            dur="2s"
            repeatCount="indefinite"
          />
        </rect>
      </g>

      {/* Candle 2 */}
      <g className="animate-float-2">
        <rect x="30" y="20" width="12" height="60" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="60;65;60"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.2s"
          />
          <animate
            attributeName="y"
            values="20;15;20"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </rect>
        <rect x="33" y="15" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="15;10;15"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </rect>
        <rect x="33" y="83" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="83;78;83"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </rect>
      </g>

      {/* Candle 3 */}
      <g className="animate-float-3">
        <rect x="50" y="25" width="12" height="50" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="50;45;50"
            dur="1.8s"
            repeatCount="indefinite"
            begin="0.4s"
          />
          <animate
            attributeName="y"
            values="25;30;25"
            dur="1.8s"
            repeatCount="indefinite"
            begin="0.4s"
          />
        </rect>
        <rect x="53" y="20" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="20;25;20"
            dur="1.8s"
            repeatCount="indefinite"
            begin="0.4s"
          />
        </rect>
        <rect x="53" y="78" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="78;73;78"
            dur="1.8s"
            repeatCount="indefinite"
            begin="0.4s"
          />
        </rect>
      </g>

      {/* Candle 4 */}
      <g className="animate-float-1">
        <rect x="70" y="35" width="12" height="45" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="45;40;45"
            dur="2.1s"
            repeatCount="indefinite"
            begin="0.3s"
          />
          <animate
            attributeName="y"
            values="35;40;35"
            dur="2.1s"
            repeatCount="indefinite"
            begin="0.3s"
          />
        </rect>
        <rect x="73" y="30" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="30;35;30"
            dur="2.1s"
            repeatCount="indefinite"
            begin="0.3s"
          />
        </rect>
        <rect x="73" y="83" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="83;78;83"
            dur="2.1s"
            repeatCount="indefinite"
            begin="0.3s"
          />
        </rect>
      </g>

      {/* Candle 5 */}
      <g className="animate-float-2">
        <rect x="90" y="15" width="12" height="65" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="65;70;65"
            dur="2.3s"
            repeatCount="indefinite"
            begin="0.5s"
          />
          <animate
            attributeName="y"
            values="15;10;15"
            dur="2.3s"
            repeatCount="indefinite"
            begin="0.5s"
          />
        </rect>
        <rect x="93" y="10" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="10;5;10"
            dur="2.3s"
            repeatCount="indefinite"
            begin="0.5s"
          />
        </rect>
        <rect x="93" y="83" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="83;78;83"
            dur="2.3s"
            repeatCount="indefinite"
            begin="0.5s"
          />
        </rect>
      </g>

      {/* Candle 6 */}
      <g className="animate-float-3">
        <rect x="110" y="40" width="12" height="35" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="35;30;35"
            dur="1.9s"
            repeatCount="indefinite"
            begin="0.6s"
          />
          <animate
            attributeName="y"
            values="40;45;40"
            dur="1.9s"
            repeatCount="indefinite"
            begin="0.6s"
          />
        </rect>
        <rect x="113" y="35" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="35;40;35"
            dur="1.9s"
            repeatCount="indefinite"
            begin="0.6s"
          />
        </rect>
        <rect x="113" y="78" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="78;73;78"
            dur="1.9s"
            repeatCount="indefinite"
            begin="0.6s"
          />
        </rect>
      </g>

      {/* Candle 7 */}
      <g className="animate-float-1">
        <rect x="130" y="25" width="12" height="55" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="55;50;55"
            dur="2.4s"
            repeatCount="indefinite"
            begin="0.7s"
          />
          <animate
            attributeName="y"
            values="25;30;25"
            dur="2.4s"
            repeatCount="indefinite"
            begin="0.7s"
          />
        </rect>
        <rect x="133" y="20" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="20;25;20"
            dur="2.4s"
            repeatCount="indefinite"
            begin="0.7s"
          />
        </rect>
        <rect x="133" y="83" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="83;78;83"
            dur="2.4s"
            repeatCount="indefinite"
            begin="0.7s"
          />
        </rect>
      </g>

      {/* Candle 8 */}
      <g className="animate-float-2">
        <rect x="150" y="30" width="12" height="45" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="45;40;45"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.8s"
          />
          <animate
            attributeName="y"
            values="30;35;30"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.8s"
          />
        </rect>
        <rect x="153" y="25" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="25;30;25"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.8s"
          />
        </rect>
        <rect x="153" y="78" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="78;73;78"
            dur="2.2s"
            repeatCount="indefinite"
            begin="0.8s"
          />
        </rect>
      </g>

      {/* Candle 9 */}
      <g className="animate-float-3">
        <rect x="170" y="20" width="12" height="60" fill="currentColor" rx="1">
          <animate
            attributeName="height"
            values="60;55;60"
            dur="2s"
            repeatCount="indefinite"
            begin="0.9s"
          />
          <animate
            attributeName="y"
            values="20;25;20"
            dur="2s"
            repeatCount="indefinite"
            begin="0.9s"
          />
        </rect>
        <rect x="173" y="15" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="15;20;15"
            dur="2s"
            repeatCount="indefinite"
            begin="0.9s"
          />
        </rect>
        <rect x="173" y="83" width="6" height="2" fill="currentColor">
          <animate
            attributeName="y"
            values="83;78;83"
            dur="2s"
            repeatCount="indefinite"
            begin="0.9s"
          />
        </rect>
      </g>
    </svg>
  );
};

export default AnimatedLogo;
